import { injectable } from 'inversify';
import { store } from '../../../state/store';
import {
  createIncident,
  clearIncident,
  incidentCreationViewSelector,
  IncidentProps,
} from './createIncident.view.slice';

@injectable()
export class IncidentCreationViewServices {
  incidentCreationViewSelector = incidentCreationViewSelector;

  dispatchIncidentCreationView(incident: IncidentProps) {
    store.dispatch(createIncident(incident));
  }

  dispatchClearIncidentCreationView() {
    store.dispatch(clearIncident());
  }
}
